import { Component } from '@angular/core';
import { ComponentModalConfig, FuiBaseModal, ModalSize } from 'ngx-fomantic-ui';

@Component({
  selector: 'dc-old-app-modal',
  templateUrl: './old-app.component.html',
})
export class OldAppModalComponent {
  constructor(public modal: FuiBaseModal<void, void>) {}
}

export class OldAppModal extends ComponentModalConfig<void, void> {
  constructor(size = ModalSize.Normal) {
    super(OldAppModalComponent);

    this.isBasic = true;
    this.isClosable = false;
    this.transitionDuration = 300;
    this.size = size;
  }
}
